// Action enums
export enum ActionTypes {
  SET_TITLE_PAGE = "SET_TITLE_PAGE",
  SET_URL_SUB_MENU = "SET_URL_SUB_MENU",
}
